'use strict';

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.factory("leafletUtils", function (directiveUtils) {

    return {
        addShortcuts: function (scope, element, leaflet, map) {
            var shortcuts;

            var corners = map._controlCorners,
                l = 'leaflet-',
                container = map._controlContainer;

            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = L.DomUtil.create('div', className, container);
            }

            createCorner('verticalcenter', 'left');

            var linkFn = directiveUtils.compileDirective("obsMapShortcut");
            var contentEl = null;
            linkFn(scope, function (clone) {
                clone.appendTo(element);
                contentEl = clone;
            });
            shortcuts = leaflet.control({
                position: "verticalcenterleft"
            });
            shortcuts.onAdd = function () {
                return contentEl[0];
            };
            shortcuts.addTo(map);

            contentEl[0].addEventListener(
                "MapFocus",
                (e) => {
                    map.flyTo(e.detail.location, e.detail.zoom, {
                        animate: true,
                        duration: 3
                    });
                },
                false
            );

            return shortcuts;
        }
    };
});








// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/leaflet/leaflet-utils.js